export default "__VITE_ASSET__EXuoNT7Q__"